// The deck the sign-in showcase cycles through: product features and
// console tips, derived from the catalogs that already own that copy
// (modules.js for the public product story, consoleCatalog.js for the real
// click paths) so the panel never drifts from the product. Curated picks,
// not the whole catalog — a dozen cards is a deck, forty is a manual.
import { MODULES as PRODUCT } from './modules';
import { MODULES as CONSOLE, STARTER_PROMPTS } from './consoleCatalog';

const feature = (slug) => {
  const m = PRODUCT.find((x) => x.slug === slug);
  if (!m) return null;
  return { kind: 'feature', kicker: m.kicker, title: m.tagline, body: m.card, label: m.name };
};

// `to` is the console module; `ask` a prefix of the task's phrasing (the
// asks are "a / b / c" search strings, so the headline is given by hand).
const tip = (to, ask, title) => {
  const m = CONSOLE.find((x) => x.to === to);
  const t = m?.tasks.find((x) => x.ask.startsWith(ask));
  if (!m || !t) return null;
  return { kind: 'tip', kicker: `Tip · ${m.label}`, title, body: t.steps, label: m.label };
};

const nova = {
  kind: 'tip',
  kicker: 'Tip · NoVA',
  title: 'Start with a sentence',
  body: `The console copilot takes the first step for you. Try: ${STARTER_PROMPTS.slice(0, 4).map((p) => `“${p.label}”`).join(', ')}.`,
  label: 'NoVA',
};

export const AUTH_INSIGHTS = [
  feature('nqube'),
  tip('builder', 'build / create a new app', 'Create an app in one approved plan'),
  feature('agentos'),
  tip('knowledge', 'publish a document', 'Only published documents answer'),
  feature('agent-io'),
  tip('builder', 'put my assistant on my website', 'Put the assistant on your website'),
  feature('listen'),
  tip('human-review', 'review what is waiting', 'Decide what a gate paused'),
  feature('dev-console'),
  tip('deployments', 'deploy / publish', 'UAT first, production as a promote'),
  feature('devops'),
  nova,
].filter(Boolean);
